import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { userReducer } from "./slices/userSlice";
import { traderReducer } from "./slices/traderSlice";
import { depositReducer } from "./slices/depositSlice";
import { withdrawalReducer } from "./slices/withdrawalSlice";
import cardReducer from "./slices/cardSlice";
import { traderBalanceReducer } from "./slices/traderBalanceSlice";
import { traderKassaManagementReducer } from "./slices/traderKassaManagementSlice";
import { teamReducer } from "./slices/teamSlice";
import { teamPaymentReducer } from "./slices/teamPaymentSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    trader: traderReducer,
    deposits: depositReducer,
    withdrawals: withdrawalReducer,
    card: cardReducer,
    traderBalance: traderBalanceReducer,
    traderKassaManagement: traderKassaManagementReducer,
    team: teamReducer,
    teamPayment: teamPaymentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

setupListeners(store.dispatch);

export * from "./thunks/User";
export * from "./thunks/Trader";
export * from "./thunks/Deposit";
export * from "./thunks/Withdrawal";
export * from "./thunks/Card";
export * from "./thunks/TraderBalance";
export * from "./thunks/TraderKassaManagement";
export * from "./thunks/Team";
export * from "./thunks/TeamPayment";
export {
  clearDepositMedia,
  clearDepositHistoryMedia,
} from "./slices/depositSlice";

export {
  openAddModal,
  closeAddModal,
  clearError,
  setSelectedTrader,
} from "./slices/cardSlice";

export {
  clearError as clearTraderBalanceError,
  setDepositSubmitting,
} from "./slices/traderBalanceSlice";

export {
  clearError as clearTraderKassaError,
  setSelectedTrader as setSelectedKassaTrader,
  resetTraderDetail,
} from "./slices/traderKassaManagementSlice";

export {
  clearError as clearTeamError,
  clearSelectedTeam,
} from "./slices/teamSlice";

export {
  clearError as clearTeamPaymentError,
  clearSelectedPeriod,
  clearLastAction,
} from "./slices/teamPaymentSlice";
